var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00293B",
  d: "M0 15.834V20h4.166L16.453 7.713l-4.166-4.166zM19.675 4.49a1.106 1.106 0 0 0 0-1.566l-2.6-2.6a1.106 1.106 0 0 0-1.566 0l-2.033 2.033 4.166 4.166z"
})));
export { SvgEditIcon as ReactComponent };
export default __webpack_public_path__ + "e5339fc80dad6641c67844a00cda5a5d.svg";